exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".actions {\n  text-align: center;\n}\n\n.deleteRowButton {\n  background-color: #f06b6f;\n  border-radius: 10px;\n  padding: 5px;\n  transition: background-color 0.25s;\n}\n\n.actions svg {\n  color: #ce3f3f;\n  cursor: pointer;\n}\n\n.table .ReactTable .rt-th:focus {\n  outline: none;\n}\n\n.ReactTable .rt-tbody .rt-td {\n  font-size: initial !important;\n}\n", ""]);

// exports
